export default "__VITE_ASSET__DYCiHA$S__"